import React, { Fragment } from "react";
import { Row, Col, FormGroup, Label } from "reactstrap";
import { FormCheck } from "react-bootstrap";

const ManualForm = (props) => {
  const { errors, control, register, setValue, trigger, getValues, searchSellersByName, sellers, setOptions, promiseOptions } = props;

  return (
    <Fragment>
      <Row>
        <Col>
          <FormGroup>
            <Label className="col-form-label">Manual Name</Label>
            <input name="name" type="text" {...register("name")} className={`form-control ${errors.name ? "is-invalid" : ""}`} />
            <div className="invalid-feedback">{errors.name?.message}</div>
          </FormGroup>
        </Col>
      </Row>
      {/* <Row>
        <Col>
          <FormGroup>
            <Label className="col-form-label">HS Code</Label>
            <input name="hs_code" type="text" {...register("hs_code")} className={`form-control ${errors.hs_code ? "is-invalid" : ""}`} />
            <div className="invalid-feedback">{errors.hs_code?.message}</div>
          </FormGroup>
        </Col>
      </Row> */}
    </Fragment>
  );
};

export default ManualForm;
